import React from "react";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* Logo */}
                    <div className="flex items-center">
                        <img
                            src={require('../../assets/m4m-logo.png')}
                            alt="Manage4Me Logo"
                            className="h-10 w-10 mr-3"
                        />
                        <span className="text-xl font-bold" style={{ color: '#0c1248' }}>

                        <a className="font-bold" style={{ color: '#0c1248' }} href="https://apps.manage4me.org/">Manage4Me</a>
            </span>
                    </div>

                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex space-x-8">
                        <a
                            href="#sobre"
                            className="text-gray-700 hover:text-[#0c1248] px-3 py-2 text-sm font-medium transition-colors duration-200"
                        >
                            Sobre
                        </a>
                        <a
                            href="#produtos"
                            className="text-gray-700 hover:text-[#0c1248] px-3 py-2 text-sm font-medium transition-colors duration-200"
                        >
                            Produtos
                        </a>
                        <a
                            href="#compromisso"
                            className="text-gray-700 hover:text-[#0c1248] px-3 py-2 text-sm font-medium transition-colors duration-200"
                        >
                            Compromisso
                        </a>
                        <a
                            href="#contato"
                            className="text-gray-700 hover:text-[#0c1248] px-3 py-2 text-sm font-medium transition-colors duration-200"
                        >
                            Contato
                        </a>
                    </nav>

                    {/* Mobile menu button */}
                    <div className="md:hidden">
                        <button
                            onClick={toggleMenu}
                            className="text-gray-700 hover:text-[#0c1248] p-2"
                        >
                            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
                        </button>
                    </div>
                </div>

                {/* Mobile Navigation */}
                {isMenuOpen && (
                    <div className="md:hidden bg-white border-t border-gray-100">
                        <div className="px-2 pt-2 pb-3 space-y-1">
                            <a
                                href="#sobre"
                                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-[#0c1248] hover:bg-gray-50 transition-colors duration-200"
                                onClick={toggleMenu}
                            >
                                Sobre
                            </a>
                            <a
                                href="#produtos"
                                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-[#0c1248] hover:bg-gray-50 transition-colors duration-200"
                                onClick={toggleMenu}
                            >
                                Produtos
                            </a>
                            <a
                                href="#compromisso"
                                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-[#0c1248] hover:bg-gray-50 transition-colors duration-200"
                                onClick={toggleMenu}
                            >
                                Compromisso
                            </a>
                            <a
                                href="#contato"
                                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-[#0c1248] hover:bg-gray-50 transition-colors duration-200"
                                onClick={toggleMenu}
                            >
                                Contato
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;